import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar
  },
  data() {
    return {
      addressVisible: false,
      printItems: [],
      lng: "",
      lat: ""
    };
  },
  computed: {
    exam_type: {
      get() {
        return this.$store.state.examInfo.currentExamInfo.exam_type;
      }
    }
  },
  methods: {
    getData: function() {
      this.$http
        .get(globalProvider.serviceUrl("eam_exm_ct/g/ets"), {
          params: { loading: true }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.printItems = data.body.data;
          } else if (data.body.code == resultCode.NotSuccess) {
            if (data.body.message == "SWITCH_OFF") {
              this.$router.push({
                name: "default.closeTip",
                params: { type: "print", time: JSON.stringify(data.body.data) }
              });
            } else this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    showMap(row) {
      this.lng = row.longitude;
      this.lat = row.latitude;
      this.addressVisible = true;
    },
    print(row, batch_id) {
      if (this.exam_type != 2) {
        this.$confirm(
          "打印准考证以后将不能取消预约，是否确定打印准考证?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.$confirm("请再次确定", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let routeData = this.$router.resolve({
              name: "default.printPage",
              query: {
                regId: row.review_exam_cert_no
                  ? row.review_exam_cert_no
                  : row.exam_cert_no,
                batch_id: batch_id,
                sd: row.subject_id
              }
            });
            window.open(routeData.href, "_blank");
          });
        });
      } else {
        let routeData = this.$router.resolve({
          name: "default.printPage",
          query: {
            regId: row.review_exam_cert_no
              ? row.review_exam_cert_no
              : row.exam_cert_no,
            batch_id: batch_id,
            sd: row.subject_id
          }
        });
        window.open(routeData.href, "_blank");
      }
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "4");
    this.getData();
  }
};